import { render, staticRenderFns } from "./Messenger.vue?vue&type=template&id=f5b178d4&scoped=true&"
import script from "./Messenger.vue?vue&type=script&lang=ts&"
export * from "./Messenger.vue?vue&type=script&lang=ts&"
import style0 from "./Messenger.vue?vue&type=style&index=0&id=f5b178d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b178d4",
  null
  
)

export default component.exports